import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import moment from 'moment';
import { FacturaCvfControllerService, CvfControllerService} from 'api-rest';

@Component({
  selector: 'lib-holders-cvf-signed-upload-dialog',
  templateUrl: './holders-cvf-signed-upload-dialog.component.html',
  styleUrls: ['./holders-cvf-signed-upload-dialog.component.scss']
})
export class HoldersCvfSignedUploadDialogComponent {

  adjuntosBlob: Array<any> = [];
  documento: File | undefined;
  isDragging = false;
  files: File[] = [];
  
  grid: any[] = [];
  headArray: any[] = [
    {
      Head: 'Documento',
      FieldName: 'name',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Borrar',
          show: { params:'canAccessDelete', accion: 'delete' },
        },
      ],
      width: '2',
      permanent: true,
    },
  ];

  constructor(
    @Inject('environment') private environment: any,
    public dialogRef: MatDialogRef<HoldersCvfSignedUploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private facturaCvfControllerService: FacturaCvfControllerService,
    private cvfControllerService: CvfControllerService
  ) {
  }

  closeDialog(): void {
    this.dialogRef.close(null);
  }

  attachAdjunto(archivos: any): void {
    if (archivos != null && archivos != undefined && archivos.length > 0) {
      this.addFiles(archivos);
    }
  }

  action(event: any) {
    if (event.nameButton == 'delete') {
      //Borrar registro
      this.deleteFile(event);
    }
  }

  canAccessDelete(): boolean {
    return true;
  }

  deleteFile(element:any){
    this.adjuntosBlob = this.adjuntosBlob.filter((item: any) => item.name !== element.name);
    this.grid = this.adjuntosBlob.map(item => ({ name: item.name, canAccessDelete: true }));
    // Update files array for displaying in the list if needed, though grid is used for the table
    this.files = this.files.filter(f => f.name !== element.name);
  }

  saveData(){
    if (this.adjuntosBlob == null || this.adjuntosBlob == undefined || this.adjuntosBlob.length == 0) {
      this.snackBarSrv.showSnackBar('Adjunte documento', 'error');
      return;
    }
    
    let fechaFirma = moment().format('YYYY-MM-DD');
    let id = this.data.info.id;

    this.spinnerSrv.loadingShow();
    this.cvfControllerService.subirCvfFirmado(id, fechaFirma, this.adjuntosBlob[0]).subscribe({
      next: () => {
        this.snackBarSrv.showSnackBar(
          'Documento subido correctamente',
          'success'
        );
        this.dialogRef.close(true);
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
      complete: () => {
        this.spinnerSrv.loadingHide();
      },
    });
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
    if (event.dataTransfer && event.dataTransfer.files) {
      this.addFiles(event.dataTransfer.files);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.addFiles(input.files);
    }
  }

  addFiles(fileList: FileList) {
    if (fileList.length > 0) {
      const pFile = fileList.item(0);
      
      if (this.isValidFile(pFile)) {
        // Clear existing files to enforce single file upload
        this.adjuntosBlob = [];
        this.files = [];

        if (pFile) {
            this.adjuntosBlob.push(pFile);
            this.files.push(pFile);
        }
        
        this.grid = this.adjuntosBlob.map(item => ({ name: item.name, canAccessDelete: true }));
        this.documento = undefined;
      }
    }
  }

  isValidFile(archivo: File | null){
    let isValid = false;
    if (archivo != null) {
      const isPDF = archivo.type === 'application/pdf' && archivo.name.toLowerCase().endsWith('.pdf');
      if (!isPDF) {
        this.snackBarSrv.showSnackBar(
          'Solo se permiten archivos pdf',
          'error'
        );
      } else if (archivo.size === 0) {
        this.snackBarSrv.showSnackBar(
          'No se puede subir un fichero vacío',
          'error'
        );
      } else if (archivo.size > 12 * 1024 * 1024) { // 12 MB
        this.snackBarSrv.showSnackBar(
          'El fichero supera el tamaño máximo permitido de 12 MB',
          'error'
        );
      }else{
        isValid = true;
      }
    }
    
    return isValid;
  }

}
